import { render } from "./registrar-gasto.vue?vue&type=template&id=6c2e7338&scoped=true"
import script from "./registrar-gasto.vue?vue&type=script&lang=js"
export * from "./registrar-gasto.vue?vue&type=script&lang=js"

import "./registrar-gasto.vue?vue&type=style&index=0&id=6c2e7338&scoped=true&lang=css"
import "./registrar-gasto.vue?vue&type=style&index=1&id=6c2e7338&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c2e7338"]])

export default __exports__